import { Component, Input, OnInit } from '@angular/core';
import { MasterProject } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-listing-action-dropdown',
  templateUrl: './listing-action-dropdown.component.html',
  styleUrls: ['./listing-action-dropdown.component.scss'],
  host: { class: 'listing-action-dropdown' },
})
export class SharedListingActionDropdownComponent {
  @Input() actions?: any[];

  @Input() location?: string;
  @Input() task?: any;
  @Input() phase?: any;
  @Input() project?: any;
  @Input() masterProject?: MasterProject;
  @Input() filteredActionIds?: string[];

  @Input() level?: 'task' | 'phase' | 'project' | 'master' | 'other';

  @Input() buttonStyle: '3dots' | 'menu' = '3dots';

  getSecondaryActions(): any {
    return this.actions;
  }
}
